import format from '@/module/util/format'

export default {
	props: {
		event: {
			type: Array,
			required: true
		}
	},

	methods: {
		...format
	}
}
